import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import TasksModule from '@modules/TasksModule';
import {
  CallEvent,
  PcsConversationFetchedEvent,
} from '@modules/SoftPhoneModule/types';
import { SpeedToLeadTaskView } from './components/SpeedToLeadTaskView';
import { SpeedToLeadTaskRow } from './components/SpeedToLeadTaskRow';
import { SPEED_TO_LEAD_OUTBOUND_TASK_TYPE } from './types';
import handleStlCallAnswered from './events/handleStlCallAnswered';
import handleStlCallEnded from './events/handleStlCallEnded';
import handleStlPcsConversationFetched from './events/handleStlPcsConversationFetched';

class SpeedToLeadTasksModule extends AppModule {
  override events = []; // this module emits no events; it only listens to events from other modules

  override preload(): void {
    // Registered unconditionally — the feature flag (featureSpeedToLeadOutboundingV0)
    // is enforced in the UI (TaskList, InboxPage), so registering when the flag is off
    // is harmless: no tasks of this type can be claimed and nothing surfaces the view.
    // Gating here caused a bug where isEnabled() always returned false at preload time
    // because LaunchDarkly initializes asynchronously after sign-in.
    TasksModule.registerTaskDefinition({
      key: 'speed-to-lead',
      category: 'Outbound',
      types: [SPEED_TO_LEAD_OUTBOUND_TASK_TYPE],
      taskRowComponent: SpeedToLeadTaskRow,
      taskViewComponent: SpeedToLeadTaskView,
    });

    this.app.events.on('phone.call.answered', (ev: CallEvent) =>
      handleStlCallAnswered(ev),
    );

    this.app.events.on('phone.call.ended', (ev: CallEvent) =>
      handleStlCallEnded(ev),
    );

    this.app.events.on(
      'phone.pcs.conversation.fetched',
      (ev: PcsConversationFetchedEvent) => handleStlPcsConversationFetched(ev),
    );
  }
}

export default new SpeedToLeadTasksModule(
  appManager.events,
  appManager.logger('SpeedToLead'),
);
